import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import FormButton from 'components/form-components/FormButton';
import SingleCheckBoxField from 'components/form-components/SingleCheckBoxField';

import settingIcon from 'assets/images/icons/setting-grey.svg';
import { cloneDeep } from 'lodash';

const DashboardsSetupDetailPermission = ({
  openDropdown,
  setOpenDropdown,
  permissionsList,
  setPermissionsList,
}) => {
  const { t } = useTranslation();

  const [values, setValues] = useState({
    dataConnection: false,
    detailOptions: {
      companySQL: false,
      formSQL: false,
      formStructureSQL: false,
    },
  });

  const dashboardSetupDetailOptions = [
    { value: 'companySQL', displayValue: 'Company SQL' },
    { value: 'formSQL', displayValue: 'form SQL' },
    { value: 'formStructureSQL', displayValue: 'form structure SQL' },
  ];

  const handleToggleChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleDetailToggleChange = (fieldId, checked) => {
    setValues((prev) => ({
      ...prev,
      detailOptions: { ...prev.detailOptions, [fieldId]: checked },
    }));
  };

  useEffect(() => {
    const dashboardSetup = permissionsList?.system?.moduleLevels?.dashboard_setup;
    const perms = dashboardSetup?.dashboardSetupPermission;
    if (!perms) return;

    setValues((prevState) => ({
      ...prevState,
      ...(perms.companySQL || perms.formSQL || perms.formStructureSQL
        ? { dataConnection: true }
        : {}),
      detailOptions: { ...prevState.detailOptions, ...perms },
    }));
  }, []);

  useEffect(() => {
    setPermissionsList((prev) => {
      const updated = cloneDeep(prev);
      const dashboard_setup = updated.system?.moduleLevels?.dashboard_setup;
      if (!dashboard_setup) return prev;

      if (!values.dataConnection && !dashboard_setup.dashboardSetupPermission) {
        return prev;
      }

      if (values.dataConnection) {
        dashboard_setup.dashboardSetupPermission = {
          ...values.detailOptions,
        };
      } else {
        dashboard_setup.dashboardSetupPermission = {
          companySQL: false,
          formSQL: false,
          formStructureSQL: false,
        };
      }
      return updated;
    });
  }, [values]);

  const isDetailsDisabled = !values.dataConnection;

  return (
    <div className='d-flex gap-2 w-100'>
      <span className='flex-grow-0' style={{ width: '30%' }} />
      <div className='p-2 flex-grow-1 theme-background-white-5 rounded-sm'>
        <div className='d-flex align-items-center gap-3'>
          <SingleCheckBoxField
            name='dataConnection'
            text={<span>{t('text_data_connection')}</span>}
            value={values.dataConnection}
            handleChange={handleToggleChange}
            shrink
          />
          <Dropdown
            show={openDropdown && !isDetailsDisabled}
            onToggle={() => !isDetailsDisabled && setOpenDropdown((p) => !p)}
            style={{ width: '6.5rem' }}
          >
            <Dropdown.Toggle
              id='dropdown-multiselect'
              variant='none'
              className={`d-flex justify-content-end rounded-sm cursor-pointer ${
                isDetailsDisabled ? 'opacity-50 pointer-events-none' : ''
              }`}
              as='div'
            >
              <img className='p-2 cursor-pointer' src={settingIcon} alt='edit' />
            </Dropdown.Toggle>

            {openDropdown && !isDetailsDisabled && (
              <Dropdown.Menu className='px-3 py-3 user-select-none' style={{ width: '20rem' }}>
                <div className='row mb-2 fw-bold'>
                  <span className='text-capitalize'>{t('text_data_connection')}</span>
                </div>

                {dashboardSetupDetailOptions.map((opt) => {
                  const fieldId = opt.value;
                  const isChecked = !!values.detailOptions[fieldId];

                  return (
                    <div key={fieldId} className='row mb-2 align-items-center'>
                      <SingleCheckBoxField
                        name={fieldId}
                        text={<span>{opt.displayValue}</span>}
                        value={isChecked}
                        handleChange={(name, val) => handleDetailToggleChange(fieldId, val)}
                        shrink
                      />
                    </div>
                  );
                })}

                <FormButton
                  text='button_close'
                  variant='green-2'
                  shrink
                  classes='w-100'
                  onClick={() => setOpenDropdown(false)}
                />
              </Dropdown.Menu>
            )}
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

DashboardsSetupDetailPermission.propTypes = {
  openDropdown: PropTypes.bool.isRequired,
  setOpenDropdown: PropTypes.func.isRequired,
  permissionsList: PropTypes.object.isRequired,
  setPermissionsList: PropTypes.func.isRequired,
};

export default DashboardsSetupDetailPermission;
